import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
//import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Card, CardActions, Avatar, Button, CircularProgress, TextField } from '@mui/material';
import { cyan, pink, common } from '@mui/material/colors';
import { Notification, defaultTheme, useLogin } from 'react-admin';
import logo from '../../images/logo.png';

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        height: '1px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    card: {
        minWidth: 300,
    },
    avatar: {
        margin: '1em',
        textAlign: 'center',
    },
    avatarImg: {
        boxShadow: '1px 1px 2px 0.5px rgba(0,0,0,0.4)',
        objectFit: 'contain'
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        display: 'flex',
    },
};

function getColorsFromTheme(theme) {
    if (!theme) return { primary1Color: cyan[500], accent1Color: pink[400] };
    const { palette: { primary: { main: primary1Color }, secondary: { main: accent1Color } } } = theme;
    return { primary1Color, accent1Color };
}

const Login = ({ theme }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    //const dispatch = useDispatch();
   // const isLoading = useSelector(state => state.admin.loading > 0);
    const login = useLogin();

    const onSubmit = async (data) => {
        try {
            await login({
                username: data.username,
                password: data.password,
            });
            window.location.href = window.location.state ? window.location.state.nextPathname : '/';
        } catch (error) {
            console.error('Login error:', error);
        }
    };

    const muiTheme = createTheme(theme);
    const { primary1Color } = getColorsFromTheme(muiTheme);

    return (
        <ThemeProvider theme={muiTheme}>
            <div style={{ ...styles.main, backgroundColor: primary1Color }}>
                <Card sx={styles.card}>
                    <div style={styles.avatar}>
                        <Avatar
                            sx={{ width: 100, height: 100, backgroundColor: common.white }}
                            style={styles.avatarImg}
                            src={logo}
                        />
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div style={styles.form}>
                            <div style={styles.input}>
                                <TextField
                                    {...register('username', {
                                        required: 'Username is required',
                                    })}
                                    label={'Username'}
                                    fullWidth
                                    error={Boolean(errors.username)}
                                    helperText={errors.username?.message}
                                    //disabled={isLoading}
                                />
                            </div>
                            <div style={styles.input}>
                                <TextField
                                    {...register('password', {
                                        required: 'Password is required',
                                    })}
                                    type="password"
                                    label={'Password'}
                                    fullWidth
                                    error={Boolean(errors.password)}
                                    helperText={errors.password?.message}
                                   // disabled={isLoading}
                                />
                            </div>
                        </div>
                        <CardActions>
                            <Button
                                type="submit"
                                color="primary"
                                //disabled={isLoading}
                                // startIcon={
                                //     isLoading && (
                                //         <CircularProgress
                                //             size={25}
                                //             thickness={2}
                                //         />
                                //     )
                                // }
                                fullWidth
                            >
                                {'Sign In'}
                            </Button>
                        </CardActions>
                    </form>
                </Card>
                <Notification />
            </div>
        </ThemeProvider>
    );
};

Login.propTypes = {
    theme: PropTypes.object.isRequired,
};

Login.defaultProps = {
    theme: defaultTheme,
};

export default Login;
